export const UserInfo = {
    isAuth: false,
    username: 'dada',
    firstname: "Daniel",
    lastname: "Marin"
}
